import { formatDate_YMD, formatDate_YMD_AddDays } from "../_helpers";
import moment from "moment";

export const Holidays = function(_Country) {
  this.countries = _Country;
};

Holidays.prototype.searchAvailableDate = function(_Date) {
  while (this.determineAvailableDay(_Date)) {
    _Date = formatDate_YMD_AddDays(_Date, 1);
  }
  return formatDate_YMD(_Date);
};

Holidays.prototype.determineAvailableDay = function(_Date) {
  this.date = formatDate_YMD(_Date);
  let isWeekend = this.determineWeekend();
  let isHoliday = this.determineHoliDay();
  return isWeekend || isHoliday;
};

Holidays.prototype.determineWeekend = function() {
  let dateFormat = moment(this.date);
  let dayOfWeek = dateFormat.day();
  return dayOfWeek === 6 || dayOfWeek === 0;
};

Holidays.prototype.determineHoliDay = function() {
  let countryHolidays = new CountryHoliDays(this.countries);
  return countryHolidays.determineHoliday(this.date);
};

export const CountryHoliDays = function(_Country) {
  this.countries = _Country;
  this.groupHolidays = [];
  this.countryEvaluated = undefined;
  for (let country of this.countries) {
    if (country === "COL") {
      this.countryEvaluated = new Colombia();
      this.addingHolidays(this.countryEvaluated.holiDays);
    } else if (country === "MYS") {
      this.countryEvaluated = new Malaysia();
      this.addingHolidays(this.countryEvaluated.holiDays);
    } else if (country === "USA") {
      this.countryEvaluated = new EEUU();
      this.addingHolidays(this.countryEvaluated.holiDays);
    } else if (country === "MEX") {
      this.countryEvaluated = new Mexico();
      this.addingHolidays(this.countryEvaluated.holiDays);
    }
  }
};

CountryHoliDays.prototype.determineHoliday = function(_Date) {
  this.groupHolidays = [...new Set(this.groupHolidays)];
  let holiday = this.groupHolidays.indexOf(_Date);
  return holiday !== -1;
};

CountryHoliDays.prototype.addingHolidays = function() {
  if (this.groupHolidays.length === 0) {
    this.groupHolidays = this.countryEvaluated.holiDays;
  } else {
    this.groupHolidays = this.groupHolidays.concat(
      this.countryEvaluated.holiDays
    );
  }
};

export const Colombia = function() {
  this.holiDays = [
    "2021-01-01",
    "2021-01-11",
    "2021-03-22",
    "2021-04-01",
    "2021-04-02",
    "2021-05-01",
    "2021-05-17",
    "2021-06-07",
    "2021-06-14",
    "2021-07-05",
    "2021-07-20",
    "2021-08-07",
    "2021-08-16",
    "2021-10-18",
    "2021-11-01",
    "2021-11-15",
    "2021-12-08",
    "2021-12-25"
  ];
};

export const Malaysia = function() {
  this.holiDays = [""];
};

export const EEUU = function() {
  this.holiDays = [
    "2021-01-01",
    "2021-01-18",
    "2021-02-15",
    "2021-05-31",
    "2021-07-04",
    "2021-09-06",
    "2021-10-11",
    "2021-11-11",
    "2021-11-25",
    "2021-12-24",
    "2021-12-25",
    "2021-12-31"
  ];
};

export const Mexico = function() {
  this.holiDays = [
    "2021-01-01",
    "2021-01-06",
    "2021-02-01",
    "2021-02-02",
    "2021-02-05",
    "2021-02-14",
    "2021-02-17",
    "2021-02-24",
    "2021-03-15",
    "2021-03-18",
    "2021-03-20",
    "2021-03-21",
    "2021-03-28",
    "2021-04-01",
    "2021-04-02",
    "2021-04-03",
    "2021-04-04",
    "2021-04-30",
    "2021-05-01",
    "2021-05-05",
    "2021-05-10",
    "2021-05-13",
    "2021-05-15",
    "2021-05-23",
    "2021-06-03",
    "2021-06-20",
    "2021-08-15",
    "2021-09-15",
    "2021-09-16",
    "2021-09-22",
    "2021-10-12",
    "2021-10-31",
    "2021-11-01",
    "2021-11-02",
    "2021-11-15",
    "2021-11-20",
    "2021-11-21",
    "2021-12-08",
    "2021-12-12",
    "2021-12-21",
    "2021-12-24",
    "2021-12-25",
    "2021-12-28",
    "2021-12-31"
  ];
};
